import {createSlice} from '@reduxjs/toolkit';
import i18n from '../../i18n-config';
import { AppDispatch } from '../state';
import {changeLang} from '../utils/uiSlice';

export const languageSlice = createSlice({
  initialState: {
    systemLanguage: 'en',
    languages: [
      {
        lang: 'english',
        key: 'en',
      },
      {
        lang: 'french',
        key: 'fr',
      },
    ],
  },
  name: 'language',
  reducers: {
    setLanguage: (state, action) => {
      return {...state, systemLanguage: action.payload};
    },
  },
});

const {setLanguage} = languageSlice.actions;

export const changeLanguage = (language:string) => async (dispatch:AppDispatch) => {
  try {
    // await AsyncStorage.setItem('LANG', language);
    i18n.changeLanguage(language);
    dispatch(setLanguage(language));
    dispatch(changeLang(language));
  } catch (error) {
    console.log('change language error', error);
  }
};

export default languageSlice.reducer;
